import type { Meta, StoryObj } from '@storybook/react'

import TreeDataGrid from './TreeDataGrid';
import { OPERATORS } from 'components/pages/LandingPages/data/constants';
import { CopyValueCell } from './CopyValueCell';
import ExportRegistryProvider from '../ExportRegistryProvider';

const Template = (args) => {
  return (
    <ExportRegistryProvider>
      <TreeDataGrid {...args} />
    </ExportRegistryProvider>
  )
};

const meta : Meta<typeof Template> = {
  title: "Components/TreeDataGrid",
  component: Template,
  argTypes: {
    enableRowSpanning: {
      options: ["true", "false"],
      control: { type: "inline-radio" },
    },
  },
  args: {
    enableRowSpanning: "false",
  },
};

type Story = StoryObj<typeof Template>;

export default meta

const rows = [
  {
      "id": "1487",
      "path": [
          "Age"
      ],
      "operator": "less_than",
      "value": "18",
      "text": [
          "18"
      ],
  },
  {
      "id": "1488",
      "path": [
          "educationLevel"
      ],
      "operator": "in",
      "value": "Still in High School",
      "text": "Still in High School",
  },
  {
      "id": "1470",
      "path": [
          "contactState"
      ],
      "operator": "in",
      "value": "MA",
      "text": "Massachusetts",
  },
  {
      "id": "9891",
      "path": [
          "MilitaryStatus"
      ],
      "operator": "in",
  },
  {
      "id": "181b8f5f-2084-409b-8cb6-8d666e922298-0",
      "path": [
          "MilitaryStatus",
          "Active"
      ],
      "value": "Active",
      "text": "Active"
  },
  {
      "id": "181b8f5f-2084-409b-8cb6-8d666e922298-1",
      "path": [
          "MilitaryStatus",
          "Military Spouse"
      ],
      "value": "Military Spouse",
      "text": "Military Spouse"
  },
  {
      "id": "181b8f5f-2084-409b-8cb6-8d666e922298-2",
      "path": [
          "MilitaryStatus",
          "Military Dependent"
      ],
      "value": "Military Dependent",
      "text": "Military Dependent"
  },
  {
      "id": "9901",
      "path": [
          "contactCity"
      ],
      "operator": "in",
      "value": "Somewhere",
      "text": [
          "Somewhere"
      ],
  }
]

const columns = [
  {
    field: "path",
    groupable: true,
    headerName: "Field",
    flex: 1.75,
    cellClassName: 'code-text bold',
     renderCell: (params) => {
      if (params.rowNode?.depth > 0) {
        return ''
      }
      return params.value;
     },
  },
  {
    field: "operator",
    groupable: false,
    headerName: "Operator",
    cellClassName: 'bold',
    renderCell: (params) => {
      return OPERATORS.find(operator => operator.id === params.value)?.value || ''
    },
    flex: 1.5,
  },
  {
    field: "value",
    groupable: false,
    headerName: "Value",
    flex: 2,
    cellClassName: 'code-text bold',
    renderCell: CopyValueCell,
  },
  {
    field: "text",
    groupable: false,
    headerName: "Value Detail",
    flex: 2,
  },
  {
    field: '__tree_data_group__',
    width: 100
  }
]

export const Default : Story = {
  args: {
    enableRowSpanning: "false",
    rows: rows,
    columns: columns,
  },
}
